import { Grid, IconButton, InputBase, Paper } from '@material-ui/core';
import Add from '@material-ui/icons/Add';
import Remove from '@material-ui/icons/Remove';
import React from 'react';
import { numberInputFieldStyles } from './number-input-field-styles';

const NumberInputField = ({
  handleChange,
  value,
  minimum = 0,
  disabled,
  bigSize = false,
  givenMax,
}: INumberInputFieldProps): JSX.Element => {
  const classes = numberInputFieldStyles();

  const incrementValue = (): void => {
    handleChange(value + 1);
  };

  const decrementValue = (): void => {
    if (value > minimum) {
      handleChange(value - 1);
    }
  };

  return (
    <Paper className={bigSize ? classes.bigPaper : classes.paper}>
      <Grid container justifyContent='space-between' wrap='nowrap'>
        <Grid item>
          <IconButton
            onClick={(): void => decrementValue()}
            data-testid='number-input-field-decrease'
            disabled={disabled || value === minimum}
            className={bigSize ? classes.bigCircular : classes.circular}
          >
            <Remove className={bigSize ? classes.addRemove : ''} />
          </IconButton>
        </Grid>
        <Grid item>
          <InputBase
            type='number'
            value={value}
            classes={{ root: classes.inputRoot, input: classes.inputField }}
            data-testid='number-input-field-value'
          />
        </Grid>
        <Grid item>
          <IconButton
            onClick={(): void => incrementValue()}
            data-testid='number-input-field-increase'
            disabled={givenMax ? value === givenMax : disabled}
            className={bigSize ? classes.bigCircular : classes.circular}
          >
            <Add className={bigSize ? classes.addRemove : ''} />
          </IconButton>
        </Grid>
      </Grid>
    </Paper>
  );
};

interface INumberInputFieldProps {
  value: number;
  minimum?: number;
  disabled?: boolean;
  handleChange: (value: number) => void;
  bigSize?: boolean;
  givenMax?: number;
}

export default NumberInputField;
